import React from "react";
import { useUserModel } from "../userModel";
import { ISearchField, SearchTypeEnum, TreeDsType } from "@components/YhPageHeader/Types";
import { YhPageHeader } from "@components/YhPageHeader";
import { StatusDs } from "@src/types/FmsDs";
// import { BranchDs } from "@utils/constants";


export function PageHeader() {
    const {
        orgDs,
        roleDs,
        searchParam,
        userTypeDs,
        onReset,
        onSearch,
        loadData,
        updateSearchParam,
    } = useUserModel();

    const searchFields: ISearchField[] = [

        {
            type: SearchTypeEnum.TreeSelect,
            xxl: 4,
            span: 4,
            placeholder: "所属机构",
            fieldName: "orgCode",
            size: "small",
            disabled: false,
            treeDs: orgDs as unknown as TreeDsType[]
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "用户状态",
            fieldName: "status",
            size: "small",
            disabled: false,
            options: StatusDs
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "所属角色",
            fieldName: "roleCode",
            size: "small",
            disabled: false,
            options: roleDs
        },
        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "用户姓名",
            fieldName: "name",
            size: "small",
            disabled: false
        },
        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "联系电话",
            fieldName: "phone",
            size: "small",
            disabled: false
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "用户类型",
            fieldName: "userTypeCode",
            size: "small",
            disabled: false,
            options: userTypeDs
        },

    ]


    return (
        <YhPageHeader
            title="用户管理"
            searchValues={searchParam}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={onReset}
        />
    );
}